@solidale.controller 'LocMyfavCtrl', ['$rootScope', '$scope', '$timeout', '$q', 'Likeit', 'Useradmin', ($rootScope, $scope, $timeout, $q, Likeit, Useradmin) ->


	Likeit.index($rootScope.user.uid).then (resp)->
		$scope.favs = resp.data
]